.ux-cookie-layer {
    font-family: var(--ux-cookie-layer-font-normal);
    font-weight: var(--ux-cookie-layer-font-weight-normal);
    font-size: var(--ux-cookie-layer-font-size-normal);
    line-height: var(--ux-cookie-layer-line-height-normal);
    overflow: visible;
    text-align: start;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;

    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

    &__title {
        margin-top: 0;
        margin-bottom: 0.5em;
        font-family: var(--ux-cookie-layer-heading-font);
        font-weight: var(--ux-cookie-layer-heading-font-weight);
        font-size: var(--ux-cookie-layer-heading-font-size);
        line-height: var(--ux-cookie-layer-heading-line-height);
        color: var(--ux-cookie-layer-heading-color);
    }

    &__nav {
        flex: 0 0 auto;
        width: 100%;
        padding: 0 30px 20px;

        .ux-text-link {
            margin-right: 15px;
        }
    }

    &__switch {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: stretch;
    }
}

.ux-cookie-layer__button {
    appearance: none;
    display: flex;
    position: relative;
    flex: 1 0 auto;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
    border-radius: 0;
    outline-offset: var(--ux-cookie-layer-button-outline-offset);
    min-height: var(--ux-cookie-layer-button-min-height);
    font-family: var(--ux-cookie-layer-button-font);
    font-size: var(--ux-cookie-layer-button-font-size);
    font-weight: var(--ux-cookie-layer-button-font-weight);
    line-height: var(--ux-cookie-layer-button-line-height);
    background-color: var(--ux-cookie-layer-button-bg-color);
    border: var(--ux-cookie-layer-button-border-width) solid
        var(--ux-cookie-layer-button-border-color);
    color: var(--ux-cookie-layer-button-text-color);
    padding: var(--ux-cookie-layer-button-padding);
    text-transform: var(--ux-cookie-layer-button-text-transform);
    transition: var(--ux-cookie-layer-button-transition);
    box-shadow: var(--ux-cookie-layer-button-shadow);

    &::before {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        width: auto;
        height: auto;
        content: "";
        background: transparent;
    }

    &:focus-visible:not(:hover) {
        outline: var(--ux-cookie-layer-button-outline-width) solid
            var(--ux-cookie-layer-button-outline-color);
        outline-offset: var(--ux-cookie-layer-button-outline-offset);
    }

    &:hover {
        background: var(--ux-cookie-layer-button-hover-bg-color);
        color: var(--ux-cookie-layer-button-hover-text-color);
        border-color: var(--ux-cookie-layer-button-hover-border-color);
    }

    &:active {
        color: var(--ux-cookie-layer-button-active-text-color);
        border-color: var(--ux-cookie-layer-button-active-border-color);
        background-color: var(--ux-cookie-layer-button-active-bg-color);
        box-shadow: none;
    }

    &:not(:disabled):active::before {
        background-color: var(--ux-cookie-layer-button-active-highlight-color);
    }
}

.ux-cookie-layer__button--primary {
    background: var(--ux-cookie-layer-button-primary-bg-color);
    color: var(--ux-cookie-layer-button-primary-text-color);
    border-color: var(--ux-cookie-layer-button-primary-border-color);

    &:hover {
        background: var(--ux-cookie-layer-button-primary-hover-bg-color);
        color: var(--ux-cookie-layer-button-primary-hover-text-color);
        border-color: var(--ux-cookie-layer-button-primary-hover-border-color);
    }

    &:active {
        color: var(--ux-cookie-layer-button-primary-active-text-color);
        border-color: var(--ux-cookie-layer-button-primary-active-border-color);
        background-color: var(--ux-cookie-layer-button-primary-active-bg-color);
        box-shadow: none;
    }

    &:not(:disabled):active::before {
        background-color: var(
            --ux-cookie-layer-button-primary-active-highlight-color
        );
    }
}

.ux-cookie-layer__nav-item {
    display: inline-block;
    padding: var(--ux-cookie-layer-link-padding);
    font-size: var(--ux-cookie-layer-nav-font-size);
    color: var(--ux-cookie-layer-nav-color);
    border-bottom: var(--ux-cookie-layer-link-border-width) solid
        var(--ux-cookie-layer-link-border-color);
    text-decoration: none;
    outline: 0 none transparent;
    transition: var(--ux-cookie-layer-link-transition);
    text-transform: var(--ux-cookie-layer-nav-text-transform);

    &:not(:last-of-type) {
        margin-right: var(--ux-cookie-layer-nav-spacing);
    }

    &:hover {
        color: var(--ux-cookie-layer-link-hover-color);
        border-bottom-color: var(--ux-cookie-layer-link-hover-border-color);
    }

    &:focus {
        color: var(--ux-cookie-layer-link-focus-color);
        border-bottom-color: var(--ux-cookie-layer-link-focus-border-color);
        border-bottom-width: var(--ux-cookie-layer-link-focus-border-width);
    }

    &:active {
        color: var(--ux-cookie-layer-link-active-color);
        border-bottom-color: var(--ux-cookie-layer-link-active-border-color);
    }
}
